<template>
   <a-modal title="修改起点属性"
            :width="620"
            :visible="visible"
            :maskClosable="false"
            @ok="onOk"
            @cancel="onCancel">
         <a-form :form="form" class="pick-100 form-input about">
             <a-row>
                  <a-col :span="23">
                      <a-form-item label="起点名称">
                          <a-input v-decorator="['name',{initialValue:formData.name, rules: [{ required: true, message: '请输入起点名称'}]}]"/>
                      </a-form-item>
                 </a-col>
            </a-row>
           <WFIconSelector @change="onChangeIcon" />
         </a-form>
   </a-modal>
</template>
<script>
import WFIconSelector from './WFIconSelector'

export default {
  components: {
    WFIconSelector
  },
  props: {
  },
  data () {
    return {
      form: this.$form.createForm(this),
      formData: {
        name: null
      },
      wfNode: null,
      visible: false
    }
  },
  methods: {
    show (wfNode) {
      this.wfNode = wfNode
      this.formData.name = this.wfNode.getName()
      this.visible = true
    },
    onOk () {
      this.form.validateFields((err, values) => {
        if (err) {
          return
        }
        let data = this.form.getFieldsValue()
        this.wfNode.setName(data.name)
        this.wfNode.fixLayout()
        this.wfNode.updateXmlNode()
        this.visible = false
      })
    },
    onCancel () {
      this.visible = false
    },
    onChangeIcon (path) {
      this.wfNode.setIcon(path)
      this.onOk()
    }
  }
}
</script>
<style scoped>
</style>
